import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { reduxForm } from 'redux-form'
import { Row, Col, Panel, Modal, Button } from 'react-bootstrap'
import _ from 'lodash'
import RoomSearchListing from '../components/roomSearchListing'
import autobind from 'autobind-decorator'
import * as actions from '../redux/actions'
import { unlockRooms, changeBookingStatus, findRooms } from '../redux/actions'
import {
  roomSelectionFields,
  defaultPayingGuestValue
} from '../redux/formSchema'
import SearchBar from '../components/searchBar'
import RoomBookNavTabs from '../components/roomBookNavTabs'
import { isEmpty, getObjVal } from '../utils'
import { clearAppCache } from '../redux/stateUtils'
import BottomNavigationButtons from './bottomNavigationButtons'
import {
  allowMultipleBookingsSelector,
  guestRequirementsSelector,
  isProgramBookingSelector,
  programSelector,
  validateTnc
} from '../redux/modules/searchParamsModule'
import { roomTypes } from '../constants/roomConstants'
import { roomsSelector } from '../redux/selectors/objectSelectors'
import { isAuthenticatedSelector } from '../redux/selectors/authSelector'
import { connect } from 'react-redux'
import { getProgramDetails } from '../logic/programBookingLogic'

function didSelectAgeRestrictedRooms(selections, rooms) {
  const roomIds = _.flatMap(selections.listings, listing =>
    _.map(listing.rooms, 'roomId')
  ).filter(id => id)

  const selectedRoomTypes = roomIds.map(id => rooms[id].type)
  return (
    _.intersection(
      [roomTypes.queenSuite, roomTypes.kingSuite, roomTypes.lodge],
      selectedRoomTypes
    ).length > 0
  )
}

const ConfirmDialog = connect(state => {
  const {
    minAge,
    minAdultAge,
    programRoomType,
    childrenAllowed
  } = guestRequirementsSelector(state)
  let minLodgeAge = 7
  if (programRoomType === roomTypes.lodge) {
    minLodgeAge = childrenAllowed ? minAge : minAdultAge
  }
  return {
    minLodgeAge
  }
})(({ show, onConfirm, onCancel, minLodgeAge }) => {
  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>IMPORTANT Notice for Age Restrictions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span style={{ fontSize: '1.5rem' }}>
          <p>
            Please note: you have selected an accommodation with restrictions:
          </p>
          <ul>
            <li>
              <strong>Men’s and Women’s Lodge Rooms:</strong> Minimum age{' '}
              {minLodgeAge}
            </li>

            <li>
              <strong>King and Queen Suites:</strong> Minimum age 14, children
              are NOT allowed in the suites.
            </li>
          </ul>
        </span>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onConfirm} bsStyle={'success'}>
          I understand, continue
        </Button>
        <Button onClick={onCancel} bsStyle={'warning'}>
          Go Back
        </Button>
      </Modal.Footer>
    </Modal>
  )
})

@autobind
class SearchResults extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showSuiteConfirmDialog: false,
      formData: null
    }
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    searchResults: PropTypes.array.isRequired,
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    auth: PropTypes.object
  }

  handleSearchClick() {
    localStorage.removeItem('fields')
    localStorage.removeItem('pricePanel')
  }

  componentDidMount() {
    const {
      history: { prevPage },
      dispatch,
      location: { pathname }
    } = this.props
    // Unlocking the locked rooms before the user goes to the guest-entry page.
    dispatch(dispatch(unlockRooms))
    dispatch(actions.histResultsPage())
    dispatch(changeBookingStatus('SELECT_PROCESSING'))
    if (prevPage !== '' && pathname === '/results') {
      dispatch(actions.localRoomResults())
    }
  }

  submitForm(data) {
    let { dispatch } = this.props
    dispatch(changeBookingStatus('SELECT_COMPLETED'))
    dispatch(actions.holdRooms(data))
  }

  handleSubmitClick(data) {
    const { dispatch, rooms, shouldShowAgeDialog, program } = this.props
    dispatch(validateTnc()).then(() => {
      const childrenNotAllowed =
        program && getProgramDetails(program).childrenAllowed === false

      if (
        shouldShowAgeDialog &&
        didSelectAgeRestrictedRooms(data, rooms) &&
        !childrenNotAllowed
      ) {
        this.setState({ showSuiteConfirmDialog: true, formData: data })
      } else {
        this.submitForm(data)
      }
    })
  }

  closeAgeRestrictedDialog() {
    this.setState({
      showSuiteConfirmDialog: false,
      formData: null
    })
  }

  handleConfirmClick() {
    this.closeAgeRestrictedDialog()
    this.submitForm(this.state.formData)
  }

  handleCancelClick() {
    this.closeAgeRestrictedDialog()
  }

  componentWillMount() {
    let {
      history: { prevPage },
      location: { pathname },
      dispatch,
      checkInDate,
      checkOutDate,
      currentLocation,
      fields
    } = this.props
    if (pathname === '/results' && prevPage === '') {
      dispatch(
        findRooms(checkInDate, checkOutDate, currentLocation, fields)
      ).then(rooms => {
        this.handleSearchClick()
      })
    } else {
      let rooms = localStorage.getItem('rooms')
      if (prevPage === '' && rooms && Object.keys(rooms).length > 0) {
        let roomsObj = JSON.parse(rooms)
        this.props.dispatch(actions.findLocalRooms({}, roomsObj))
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Sets the form values to localStorage after form values are updated.
    if (prevProps != null) {
      localStorage.removeItem('searchDetails')
      let searchDetails = {
        checkInDate: prevProps.checkInDate,
        checkOutDate: prevProps.checkOutDate,
        searchResults: prevProps.searchResults
      }

      if (searchDetails) {
        localStorage.setItem('searchDetails', JSON.stringify(searchDetails))
      }

      if (prevProps.fields && prevProps.fields.listings.length > 0) {
        if (localStorage.getItem('fields')) {
          localStorage.removeItem('fields')
        }
        if (prevProps.fields) {
          localStorage.setItem('fields', JSON.stringify(prevProps.fields))
        }
      }
    }
  }

  componentWillUnmount() {
    let { dispatch } = this.props
    clearAppCache()
    dispatch(actions.histResultsPage())
  }

  render() {
    let {
      searchResults,
      auth: { authenticated },
      roomPrices,
      allowMultipleBookings,
      fields: { listings },
      isProgramBooking,
      program
    } = this.props

    let numRoomsSelected = _(listings)
      .map('numRooms.value')
      .sum()
    let disableAddingRooms = !allowMultipleBookings && numRoomsSelected >= 1

    return (
      <div>
        <Row>
          <Col md={12}>
            <RoomBookNavTabs {...this.props} />
          </Col>
        </Row>
        <Row>
          <Panel style={{ background: '#e9e0d7' }}>
            <Row>
              <Col md={12}>
                <SearchBar
                  {...this.props}
                  searchCB={this.handleSearchClick}
                  showDetailsText={false}
                />
              </Col>
              <Col md={11} className='result-widget'>
                {// Iterating over redux-form fields to get around bug: https://github.com/erikras/redux-form/issues/621
                listings.map((roomListingField, index) => {
                  if (searchResults[index]) {
                    let {
                      type,
                      gender,
                      rooms,
                      numAvailable,
                      maxGuests
                    } = searchResults[index]
                    return (
                      <RoomSearchListing
                        type={type}
                        gender={gender}
                        rooms={rooms}
                        numAvailable={numAvailable}
                        maxGuests={maxGuests || 1}
                        showRoomPicker
                        index={index}
                        roomListingField={listings[index]}
                        authenticated={authenticated}
                        dispatch={this.props.dispatch}
                        guestDetails={this.props.fields.guestDetails}
                        roomPrices={roomPrices}
                        disableAddingRooms={disableAddingRooms}
                        isProgramBooking={isProgramBooking}
                        program={program}
                      />
                    )
                  }
                })}
              </Col>
            </Row>
          </Panel>
        </Row>
        <BottomNavigationButtons
          {...this.props}
          showBack={false}
          showNext
          nextCB={this.props.handleSubmit(this.handleSubmitClick)}
          customClass='search-results'
        />
        <ConfirmDialog
          show={this.state.showSuiteConfirmDialog}
          onConfirm={this.handleConfirmClick}
          onCancel={this.handleCancelClick}
        />
      </div>
    )
  }
}

// Which props do we want to inject, given the global state?
function selectProps(state) {
  let history = state.common.history
  let searchDetails = localStorage.getItem('searchDetails')
  let searchResults = state.roomSearch.results
  let checkInDate = state.roomSearch.params.checkInDate
  let checkOutDate = state.roomSearch.params.checkOutDate
  if (
    (history.prevPage === '' || state.roomSearch.results.length === 0) &&
    searchDetails &&
    Object.keys(JSON.parse(searchDetails)).length > 0
  ) {
    let searchDetailsObj = JSON.parse(searchDetails)
    searchResults = searchDetailsObj.searchResults
    checkInDate = searchDetailsObj.checkInDate
    checkOutDate = searchDetailsObj.checkOutDate
  }
  const retObj = {
    checkInDate: checkInDate,
    checkOutDate: checkOutDate,
    searchResults: searchResults,
    initialValues: defaultValues(state),
    auth: state.common.authentication,
    allowMultipleBookings: allowMultipleBookingsSelector(state),
    isProgramBooking: isProgramBookingSelector(state),
    program: programSelector(state),
    roomPrices: state.common.roomPrices,
    history: state.common.history,
    bookingDetails: state.common.bookingDetail,
    rooms: roomsSelector(state),
    shouldShowAgeDialog: !isAuthenticatedSelector(state)
  }
  return retObj
}
function defaultValues(state) {
  let history = state.common.history
  let fields = localStorage.getItem('fields')
  let initValues = {}
  let isFormFieldsEmpty =
    history.prevPage !== '' &&
    state.form.roomSelection &&
    state.form.roomSelection.listings &&
    state.form.roomSelection.listings.length === 0
  let isPageRefreshed =
    history.prevPage === '' &&
    !isEmpty(fields) &&
    JSON.parse(fields).listings.length > 0
  let isFieldsEmpty = isFormFieldsEmpty || isPageRefreshed
  if (isFieldsEmpty && history.prevPage !== 'RESULTS') {
    let fieldsObj = JSON.parse(fields)
    if (fieldsObj && !isEmpty(fieldsObj)) {
      fieldsObj.listings = actions.formatListings(fieldsObj.listings)
      fieldsObj.guestDetails = actions.formatGuestDetails(
        fieldsObj.guestDetails
      )
      initValues = {
        listings: fieldsObj.listings,
        payingGuest: getObjVal(fieldsObj.payingGuest),
        guestDetails: fieldsObj.guestDetails
      }
    } else {
      initValues = null
    }
  } else {
    if (
      state.form.roomSelection &&
      state.form.roomSelection.listings &&
      state.form.roomSelection.listings.length > 0
    ) {
      // Returning null will get the values from the state
      initValues = null
    } else {
      initValues = {
        listings: state.roomSearch.results.map(searchResult => {
          return { numRooms: 0, rooms: [] }
        }),
        guestDetails: [],
        payingGuest: defaultPayingGuestValue
      }
    }
  }
  if (state.rooms && Object.keys(state.rooms).length > 0) {
    localStorage.removeItem('rooms')
    localStorage.setItem('rooms', JSON.stringify(state.rooms))
  }
  return initValues
}

let reduxFormWrapper = reduxForm(
  {
    form: 'roomSelection',
    destroyOnUnmount: false,
    fields: roomSelectionFields
  },
  selectProps
)

// Wrap the component to inject dispatch and state into it
export default reduxFormWrapper(SearchResults)



// WEBPACK FOOTER //
// ./src/containers/searchResults.js